import {Model} from "vue-mc";
import {Listing} from "./Listing";
import {required} from "vue-mc/validation";

export class Campaign extends Model {
  static STATUS = {
    CREATED: "created",
    SCHEDULED: "scheduled",
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
  }

  defaults() {
    return {
      id: null,
      title: null,
      subject: null,
      mailShotHtml: null,
      status: null,
      sendAt: null,
      listing: new Listing(),
      listings: []
    }
  }


  validation() {
    return {
      listing: [required],
      listings: [required],
      title: [required],
      subject: [required]
    }
  }

  options() {
    return {
      validateOnChange: true,
    }
  }
}
